
























// eslint-disable-next-line no-unused-vars
import Vue from 'vue';
import _ from 'lodash';
// eslint-disable-next-line no-unused-vars
import { Button } from 'element-ui';

import { DmsBaseComponent } from '#components/dms/common/base';

export default DmsBaseComponent.extend({
	name: 'DmsTabs',
	provide: { tabsChild: true },
	props: {
		items: { type: Object, required: true },
		dmsTabs: { type: Array as () => Vue[], required: true },
		span: { type: Number, default: 24 },
		plain: Boolean,
		selectedTab: { type: String },
		extraButtons: { type: Object as () => Record<string, Button>, default: (): Object => ({}) },
		tabsSufix: { type: Object as () => Record<string, String>, default: (): Object => ({}) },
		tabsBadges: { type: Object as () => Record<string, String>, default: (): Object => ({}) },
		isSplitLabelKey: { type: Boolean, default: false },
	},
	data() {
		return {
			tabName: Object.keys(this.items)[0],
			inputComponents: _.mapValues(this.items, () => [] as { validateState: string }[]),
		};
	},
	computed: {
		validationErrors(): Record<string, boolean> {
			return _.mapValues(this.inputComponents,
				(components) => components.reduce((a, c) => a || c.validateState === 'error', false));
		},
		buttons(): Record<string, Button> | Object {
			return Object.assign({}, this.extraButtons);
		},
		tabButtons() {
			return Object.keys(this.extraButtons);
		},
	},
	mounted() {
		this.dmsTabs.push(this);
		this.initTabName();
		Object.keys(this.inputComponents).forEach(
			(key) => this.findComponentsWithValidation(key, (this.$refs[`tab-item-${key}`] as any)[0]),
		);
	},
	destroyed() {
		this.dmsTabs.some((element, i) => {
			if (element === this) {
				this.dmsTabs.splice(i, 1);

				return true;
			}

			return false;
		});
	},
	methods: {
		tabClick(tab: any) {
			this.$emit('tab-click', tab);
			this.$emit('update:selectedTab', tab.$props.name);
			this.tabName = tab.$props.name;
		},
		buttonClick(button: any, item: any) {
			button.onClickAction(item);
		},
		getLabelKey(labelKey: string | string[2]) {
			if (Array.isArray(labelKey)) {
				return this.LocalizeMultiKeyToCommaString(`${labelKey[0]}/${labelKey[1]}`);
			}
			if (this.isSplitLabelKey) {
				const splittedLabel = decodeURIComponent(labelKey).replace(/[\"]/g, '').split('-');
				if (splittedLabel.length === 2) {
					return `${this.getText(this.label, splittedLabel[0], '', this.LocalizePopisostatni)} - ${splittedLabel[1]}`;
				}
				return this.getText(this.label, splittedLabel[0], '', this.LocalizePopisostatni);
			}
			return this.getText(this.label, labelKey, '', this.LocalizePopisostatni);
		},
		findComponentsWithValidation(key: string, element: Vue): void {
			if ('validateState' in element) this.inputComponents[key].push(element);

			return element.$children.forEach((c) => this.findComponentsWithValidation(key, c));
		},
		openTabWithErrors() {
			// eslint-disable-next-line no-return-assign
			_.some(this.validationErrors, (isError, name) => isError && !!(this.tabName = name));
		},
		initTabName() {
			if (this.selectedTab) {
				this.tabName = this.selectedTab;
			} else {
				this.$emit('update:selected-tab', null);
			}
		},
	},
});
